import PropTypes from "prop-types";
import { Box, ButtonBase, Tooltip, Typography, SvgIcon } from "@mui/material";
import { DirectionsBike } from "@mui/icons-material";
import BikeColor from "../BikeColor";
import { formatDate, formatTime } from "../../utils/dateFormat";

export default function GanchoCard({ gancho, onSelect }) {
  if (!gancho) return null;
  const available = gancho.disponible;
  const user = gancho.usuario;
  const number = String(gancho.id).padStart(2, "0");
  const ink = available ? "#226344" : "#8b5417";
  const summary = available ? (
    "Gancho disponible"
  ) : (
    <Box sx={{ p: 0.5 }}>
      <Typography variant="body2" color="inherit" fontWeight={700}>
        {user?.nombre || "Usuario sin información"}
      </Typography>
      {user?.cedula && (
        <Typography variant="caption" color="inherit" display="block">
          Documento: {user.cedula}
        </Typography>
      )}
      {user?.celular && (
        <Typography variant="caption" color="inherit" display="block">
          Celular: {user.celular}
        </Typography>
      )}
      <Typography variant="caption" color="inherit" display="block">
        {[user?.marca, user?.color, user?.serie].filter(Boolean).join(" · ") ||
          "Bicicleta sin información"}
      </Typography>
      {user?.entrada && (
        <Typography variant="caption" color="inherit" display="block">
          Entrada: {formatDate(user.entrada)} {formatTime(user.entrada)}
        </Typography>
      )}
      <Typography variant="caption" color="inherit" display="block" sx={{ mt: 0.5 }}>
        Pulsa para ver el detalle
      </Typography>
    </Box>
  );
  const content = (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          mb: 0.5,
        }}
      >
        <Typography component="span" sx={{ fontSize: "0.68rem", color: ink, fontWeight: 600 }}>
          Gancho
        </Typography>
        {available ? (
          <SvgIcon sx={{ fontSize: 18, color: ink }} viewBox="0 0 24 24">
            <path
              d="M8 4h8M12 4v10a4 4 0 1 1-8 0v-2"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </SvgIcon>
        ) : (
          <DirectionsBike sx={{ fontSize: 19, color: ink }} />
        )}
      </Box>
      <Typography
        component="span"
        sx={{ fontSize: "1.15rem", fontWeight: 750, lineHeight: 1.15, color: "#243b53" }}
      >
        #{number}
      </Typography>
      <Typography
        component="span"
        sx={{ fontSize: "0.72rem", fontWeight: 600, color: ink, mt: 0.4 }}
      >
        {available ? "Disponible" : "Ocupado"}
      </Typography>
      <Box
        sx={{
          mt: 0.75,
          minHeight: 18,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        {available ? (
          <Box component="span" aria-hidden="true" />
        ) : (
          <BikeColor value={user?.color} compact />
        )}
      </Box>
    </>
  );
  const sx = {
    p: 1,
    width: "100%",
    minHeight: 108,
    borderRadius: 2,
    border: `1px solid ${available ? "#b8dcca" : "#e9c58f"}`,
    bgcolor: available ? "#f0f9f3" : "#fff4e3",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    transition: "box-shadow 150ms, border-color 150ms",
    "&:hover": { borderColor: ink, boxShadow: "0 3px 10px #233b5310" },
    "&.Mui-focusVisible": { outline: "3px solid #6e9fc1", outlineOffset: 2 },
  };
  return (
    <Tooltip
      title={summary}
      arrow
      placement="top"
      componentsProps={{ tooltip: { sx: { bgcolor: "#193e54", maxWidth: 300 } } }}
    >
      {available ? (
        <Box component="article" aria-label={`Gancho ${number}, disponible`} sx={sx}>
          {content}
        </Box>
      ) : (
        <ButtonBase
          type="button"
          aria-label={`Ver detalle del gancho ${number}, ocupado`}
          onClick={() => onSelect?.(gancho.id)}
          sx={sx}
        >
          {content}
        </ButtonBase>
      )}
    </Tooltip>
  );
}
GanchoCard.propTypes = { gancho: PropTypes.object.isRequired, onSelect: PropTypes.func };
